/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TFunction } from "i18next";
import { IRootState } from "../../../../config/reducers";
import AdminSettingSidebarItem from "./AdminSettingSidebarItem";
import { isIndividual } from "../../../../utils/utils";
import { PERMISSIONS } from "@advapacs/common";

interface AdminSideBarProps {
  title: string;
  icon: string;
  href: string;
  show: boolean;
  can?: string[];
  allowVisibleToOwner?: boolean;
}
export const adminSidebarItems = (t: TFunction): AdminSideBarProps[] => [
  {
    title: t("general"),
    icon: "icon-cog3",
    href: "/Admin/Settings/General",
    show: true,
    can: isIndividual() ? undefined : [PERMISSIONS.VIEW_GENERAL_SETTING],
  },
  {
    title: t("security"),
    icon: "icon-shield2",
    href: "/Admin/Settings/Security",
    show: true,
    can: [PERMISSIONS.MANAGE_AUTHENTICATION],
  },
  {
    title: t("authentication"),
    icon: "icon-user-check",
    href: "/Admin/Settings/Authentication",
    show: true,
    can: [PERMISSIONS.MANAGE_AUTHENTICATION, PERMISSIONS.VIEW_AUTHENTICATION],
  },
];

const AdminSettingSidebar: FunctionComponent = () => {
  const { t } = useTranslation("navbar");
  const { secondarySidebar } = useSelector(
    (state: IRootState) => state.sidebarReducer
  );
  const location = useLocation();
  const items = adminSidebarItems(t);
  const selectedMenuItemName =
    items.find((i) => i.href === location.pathname) || items[1];
  const renderSidebarItems = () => {
    return items
      .filter((i) => i.show)
      .map((item) => (
        <AdminSettingSidebarItem
          key={item.title}
          href={item.href}
          title={item.title}
          selectedMenuItemName={selectedMenuItemName?.title || items[1]?.title}
          icon={item.icon || ""}
          can={item?.can}
          allowVisibleToOwner={item?.allowVisibleToOwner}
        />
      ));
  };
  return (
    <div>
      <ul
        className={`nav nav-tabs nav-tabs-vertical flex-column wmin-md-200 w-250 mb-md-0 border-bottom-0 nav-mobile ${
          secondarySidebar ? "nav-mobile-expand" : ""
        }`}
      >
        {renderSidebarItems()}
      </ul>
    </div>
  );
};

export default AdminSettingSidebar;
